import { ApplicationRef, ComponentRef, createComponent, EnvironmentInjector, inject, Injectable, Injector } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { ConfomerComponent } from './confomer.component';

interface conformerBody {
  title: string;
  description: string;
  type: 'delete' | 'update' | 'create';
}

@Injectable({
  providedIn: 'root'
})
export class ConfomerService {
  private appRef = inject(ApplicationRef);
  private injector = inject(EnvironmentInjector);

  private openModel(options: { title: string; message: string; type?: 'delete' | 'update' | 'create' }): Promise<boolean> {
    const subject = new Subject<boolean>();
    const componentRef: ComponentRef<ConfomerComponent> = createComponent(ConfomerComponent, {
      environmentInjector: this.injector,
    });

    componentRef.setInput('title', options.title);
    componentRef.setInput('message', options.message);
    componentRef.setInput('type', options.type || 'delete');

    // ✅ Call the open() method on the instance
    componentRef.instance.open(); // <--- THIS IS MISSING

    componentRef.instance.confirm.subscribe((result: boolean) => {
      subject.next(result);
      subject.complete();
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    });

    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    return firstValueFrom(subject);
  }

  /**
   * Opens confirm dialog using a predefined key from ConfirmConfirmModelMessage
   */
  Open(title:string, message:string): Promise<boolean> {
    return this.openModel({ title, message });
  }



}
